"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GROUPED_PRODUCTS = void 0;
const GROUPED_PRODUCTS = exports.GROUPED_PRODUCTS = 'grouped-products';
//# sourceMappingURL=constants.js.map